var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5548 2.29305C16.3672 2.10537 16.1127 1.99995 15.8474 2C15.582 2.00005 15.3275 2.10557 15.14 2.29332L4.79247 12.6533C4.60519 12.8408 4.5 13.0949 4.5 13.36V17C4.5 17.5523 4.94772 18 5.5 18H9.1586C9.42389 18 9.67831 17.8946 9.86586 17.707L20.2073 7.361C20.5976 6.97051 20.5976 6.33759 20.2073 5.9471L16.5548 2.29305ZM6.5 13.7738L15.8478 4.41479L18.0861 6.65405L8.74426 16H6.5V13.7738ZM3.5 20C2.94772 20 2.5 20.4477 2.5 21C2.5 21.5523 2.94772 22 3.5 22H21.5C22.0523 22 22.5 21.5523 22.5 21C22.5 20.4477 22.0523 20 21.5 20H3.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilOutline);
export default __webpack_public_path__ + "static/media/pencil-outline.7d2e216ca9159a12b3e077d2c6dc7e8e.svg";
export { ForwardRef as ReactComponent };